import React from 'react';


const BudgeContext = React.createContext();
export default BudgeContext;